function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export default function CheckedIcon(props) {
  let path = /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M1005.741 150.947c-24.402-24.408-63.904-24.41-88.308-0.002l-589.653 589.653-221.212-221.212c-24.402-24.408-63.904-24.41-88.308-0.002-24.346 24.348-24.346 63.962 0 88.306l265.369 265.371c24.398 24.396 63.906 24.4 88.306 0l633.807-633.809c24.344-24.346 24.344-63.962 0-88.304z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1005.741 150.947c-24.402-24.408-63.904-24.41-88.308-0.002l-430.411 430.411v176.612l518.719-518.717c24.344-24.346 24.344-63.962 0-88.304z"
  })));
  return path;
}
